import { Component, OnInit, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { G_ComplainsSuggestionsViewModel } from 'src/app/viewmodels/g-settings/G_ComplainsSuggestionsViewModel';
import { DefineAccountviewModel } from 'src/app/viewmodels/g-customer/DefineAccountviewModel';
import { GPackagesViewModel } from 'src/app/viewmodels/g-packages/GPackagesViewModel';
import { GVechileViewModel } from 'src/app/viewmodels/g-vehicle/GVechileViewModel';
import { GItemDefiningViewModel } from 'src/app/viewmodels/g-item/GItemDefiningViewModel';
import { G_SaleMasterViewModel } from 'src/app/viewmodels/g-sale/G_SaleMasterViewModel';
import { ActivatedRoute, Router } from '@angular/router';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { HttpClient } from '@angular/common/http';
import { SaleDetailViewModel } from 'src/app/viewmodels/g-sale/SaleDetailViewModel';
import { G_TagsViewModel } from 'src/app/viewmodels/g-sale/G_TagsViewModel';
import { ItemViewModel } from 'src/app/viewmodels/ItemViewModel';
import { GPackageItemViewModel } from 'src/app/viewmodels/g-packages/GPackageItemViewModel';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { SaleDetailModel, SaveSaleMasterRequest } from 'src/app/viewmodels/g-purchase/GPurchaseViewModel';

@Component({
  selector: 'app-direct-sale-invoice',
  templateUrl: './direct-sale-invoice.component.html',
  styleUrls: ['./direct-sale-invoice.component.scss']
})
export class DirectSaleInvoiceComponent implements OnInit {
  modalRef: BsModalRef;
  disabled = true;
  @Input() public modal_title: any;
  @Input() public bsmRef: BsModalRef;
  @Output() onSubmitted = new EventEmitter<any>();
  public component_Title = 'Direct Sale Invoice';
  public vehicleDetail: any = [];
  public complaintsType: any = [];
  public ccomplaintsType: 'complaintsType';
  public packageTypes: any = [];
  public cvehicleDetail = 'vehicleDetail';
  public selectedvehicleDetail: any = [];
  public vm: SaveSaleMasterRequest = new SaveSaleMasterRequest();
  public saleDetailVM: any = [];
  public services: any = [];
  public selectedServices: any = [];
  public cpackageTypes = 'packageTypes';
  public items: any = [];
  public brands: any = [];
  public selectedBrands: any = [];
  public models: any = [];
  public selectedModels: any = [];
  public citems: any = 'items';
  public cbrands: any = 'brands';
  public cmodels: any = 'models';
  public spareParts: any = [];
  public selectedSpareParts: any = [];
  public selectedPacakgeTypes: any = [];
  public tags: any = [];
  public selectedTagList: any;
  public selectedsaleDetail: any[];
  public saleDetail: any[];
  public csaleDetail: any[];
  public thumbnail: any;
  public ComName: any;
  public Address: any;
  public contect: any;
  public calingUrl: string;
  public urlId: string;
  public client: any;
  public tagsJoin: string = "";
  public partsAmount: number = 0;
  public serviceAmount: number = 0;
  public totalVat: number = 0;
  public packageAmount: number = 0;
  public discountAmount: number = 0;

  constructor(private route: ActivatedRoute,
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private http: HttpClient,
    public _router: Router,
    private _localStorageService: LocalStorageService) {

  }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.getimage();
    debugger
    this.vm = new SaveSaleMasterRequest();
    //
    this.saleDetailVM = new SaleDetailModel();
    //console.log(this.vm);
    this.calingUrl = this._router.url;
    this.route.queryParams.subscribe(params => {
      this.urlId = params['id'];
    });
    this._jq.showSpinner(true);
    this._uow.gSaleService.GetGSaleByIdAsync(this.urlId).subscribe((res: any) => {
      debugger
      this.vm = res;
      this.tagsJoin = this.vm.salesTagsList.map(tag => tag.name).join(", ");

      this.vm.spareParts.forEach(x => {
        this.partsAmount += x.totalAmount;
        this.totalVat += x.vatAmount;
        if (x.discountAmount > 0) {
          this.discountAmount += (x.discountAmount * x.quantity);
        }
      });

      this.vm.services.forEach(x => {
        this.serviceAmount += x.totalAmount;
        this.totalVat += x.vatAmount;
        if (x.discountAmount > 0) {
          this.discountAmount += (x.discountAmount * x.quantity);
        }
      });

      this.packageAmount = this.partsAmount + this.totalVat + this.serviceAmount;
      console.log(res);
      this._jq.showSpinner();
    }, (err) => {
      console.log(err);
      this._jq.showSpinner();
    })

  }


  openModal(template: TemplateRef<any>, lvl: number = 1) {
    if (lvl == 1) {
      this.modalRef = this._uow.modalServiceEx.show(template);
    }
    // if (lvl == 2) {
    //   this.modalRefLv2 = this._modalService.show(template);
    // }
  }

  openModalLg(template: TemplateRef<any>, itemtype?) {

    this.openModal(template);
    this.modalRef.setClass('modal-lg');
  }

  onButtonClick() {
    this._jq.showSpinner(true);
    this._router.navigate(['/direct-sale-list'])
  }


  getimage() {

    this._uow.gSettingService.GetHeaderFootersDropDownAsync().subscribe((baseImage: any) => {
      console.log(baseImage);
      debugger;
      if (baseImage != undefined && baseImage !== null) {
        if (baseImage.attachment != undefined && baseImage.attachment !== null) {

          this.thumbnail = `https://fleetdesks.s3.eu-central-1.amazonaws.com/${baseImage.attachment}`;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        } else {
          this.thumbnail = baseImage.compName;
          this.ComName = baseImage.compName;
          this.Address = baseImage.address;
          this.contect = baseImage.contact;
        }
      }
    }, (err) => {
      console.log(err);
    })
  }

  onItemSubmitted(e) {
    if (e == true) {
      //this.getList();
      //this.getTags();
      this._jq.showSpinner(false);
    }
  }

}
